import { TextField } from "@mui/material";

export default function CustomField(props) {
  return (
    <TextField
      margin="dense"
      fullWidth
      size="small"
      type={props.type || "text"}
      {...props}
    />
  );
}
